import { render } from "./SearchQuestButton.vue?vue&type=template&id=59bb76b6&scoped=true"
import script from "./SearchQuestButton.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchQuestButton.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchQuestButton.vue?vue&type=style&index=0&id=59bb76b6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bb76b6"]])

export default __exports__